import { errorHandleAction } from 'components/error-handle/actions';
import { put, select } from 'redux-saga/effects';
import { collectionSelector } from 'common/selectors/collection';
import { unMarkVideoFeaturedApi } from 'common/api/videos';
import { collectionIsLoadingAction } from 'common/actions';
import { fetchChannelsApi, fetchCollectionApi } from 'common/api';
import { collectionSetInStoreAction } from 'common/actions/collection';
import { channelsSuccessAction } from 'common/actions/channels';
import { getVideosPerPageSelector } from 'common/selectors';
import { REDUX_NOTIFICATION_TYPES, reduxNotificationAction } from 'components/redux-notification';
import i18next from 'i18next';

export function* unMarkVideoFeaturedEffect({ payload }) {
  try {
    const perPage = yield select(getVideosPerPageSelector);
    const collection = yield select(collectionSelector);
    yield unMarkVideoFeaturedApi(collection.channelId, payload.video.id);
    yield put(collectionIsLoadingAction());
    const { video, pageNumber, sort } = payload;
    const newCollection = yield fetchCollectionApi({
      channelId: video.currentChannel,
      pageNum: pageNumber,
      perPage,
      sorting: sort,
      featuredFirst: true,
    });
    const channels = yield fetchChannelsApi();

    yield put(collectionSetInStoreAction(newCollection));
    yield put(channelsSuccessAction(channels));
    yield put(
      reduxNotificationAction(
        i18next.t('unmark_video_as_featured_notification_success'),
        true,
        5,
        REDUX_NOTIFICATION_TYPES.SUCCESS
      )
    );
  } catch (error) {
    yield put(errorHandleAction(error, error.status));
  }
}
